module.exports = __webpack_public_path__ + "img/spark.3a9b3c18.svg";